export const profilMapping = {
  'Marche': 'basic_pedestrian',
  'Déficience motrice': 'cnig_wheelchair_user',
  'Déficience visuelle': 'cnig_visually_impaired_user',
  'Déficience auditive': 'basic_pedestrian',
  'Déficience mentale': 'basic_pedestrian'
};

export const convertProfiltForApi = function(profil){

  function getNested(obj, ...args) {
    return args.reduce((obj, level) => obj && obj[level], obj);
  }

  return getNested(profilMapping, profil);
};
